import { IEventListItem } from '@core/interfaces/event/event-list-item.interface';
import { EventBase } from './event-base.model';

export class EventListItem extends EventBase implements IEventListItem {

  readonly auditoriumName: string;
  readonly maxCapacity: number;
  readonly venueName: string;

  constructor(iEvent: IEventListItem) {
    super(iEvent);

    this.auditoriumName = iEvent.auditoriumName;
    this.maxCapacity = iEvent.maxCapacity;
    this.venueName = iEvent.venueName;
  }

}
